import type { RiskStatus } from "./index.ts";

export const RISK_RULES = Object.freeze({
  cautionDrawdownPct: 4,
  elevatedDrawdownPct: 7.5,
  delayedAfterSeconds: 180,
  offlineAfterSeconds: 600,
});

export function classifyRiskStatus(
  currentDrawdownPct: number,
  lastUpdatedAt: number,
  now: number,
): RiskStatus {
  if (now - lastUpdatedAt > RISK_RULES.offlineAfterSeconds) return "OFFLINE";
  if (currentDrawdownPct >= RISK_RULES.elevatedDrawdownPct) return "ELEVATED";
  if (currentDrawdownPct >= RISK_RULES.cautionDrawdownPct) return "CAUTION";
  return "NORMAL";
}
